import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const ThemeContext = createContext(null);

export const THEMES = ["light", "dark", "gold"];
const DEFAULT_THEME = "gold";

function readStoredTheme() {
  try {
    const saved = localStorage.getItem("vp-theme");
    return THEMES.includes(saved) ? saved : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  root.classList.remove("light", "dark", "gold");
  if (theme === "light") root.classList.add("light");
  else if (theme === "gold") root.classList.add("dark", "gold");
  else root.classList.add("dark");
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() =>
    typeof window === "undefined" ? DEFAULT_THEME : readStoredTheme()
  );

  useEffect(() => {
    applyTheme(theme);
    try {
      localStorage.setItem("vp-theme", theme);
    } catch {
      /* stockage indisponible : le thème reste appliqué pour la session */
    }
  }, [theme]);

  const setTheme = useCallback((next) => {
    setThemeState(THEMES.includes(next) ? next : DEFAULT_THEME);
  }, []);

  const toggle = useCallback(
    () => setThemeState((t) => THEMES[(THEMES.indexOf(t) + 1) % THEMES.length]),
    []
  );

  const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
}
